import * as React from "react";
import CategoryPreviewWrapper from "./CategoryPreviewWrapper";
import { Fragment, useEffect, useMemo, useState } from "react";
import { DataTable } from "../../../../../../../components/DataTable";
import { useTranslation } from "react-i18next";
import { Box, Flex, Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import { NumberField } from "../../../../../../../components/NumberField";
import { translateSubElementString } from "../../../../../../../utils";

function BusinessTravelPreview({ currentElement: { items, transportModeItems, totalCo2Emissions } }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.scopeThree.inputs.businessTravel"
  });
  const questionnaireKeyPrefix = "organizationQuestionnaire.scope3.inputs";
  const { t: inputsTranslation, i18n } = useTranslation("translation", {
    keyPrefix: questionnaireKeyPrefix
  });

  const [businessTravelData, setBusinessTravelData] = useState([]);

  useEffect(() => {
    if (items) {
      setBusinessTravelData(items.map(item => {
        return {
          modeOfTransport: item.modeOfTransport && item.modeOfTransport !== "" ?
            inputsTranslation(`modeOfTransportOptions.${item.modeOfTransport}`) : "",
          transportSubtype: item.transportSubtype && item.transportSubtype !== "" ?
            inputsTranslation(`transportSubtypeOptions.${item.modeOfTransport}.${item.transportSubtype}`) : "",
          emissions: item.co2Emissions
        };
      }));
    }
  }, [items, inputsTranslation]);

  const columns = useMemo(
    () => [
      {
        header: t("modeOfTransport"),
        accessorKey: "modeOfTransport",
        size: 100
      },
      {
        header: t("transportSubtype"),
        accessorKey: "transportSubtype",
        size: 100
      },
      {
        header: translateSubElementString("reportsPage.scopeThree.inputs.businessTravel.emissions"),
        accessorKey: "emissions",
        size: 100
      }
    ],
    [t]
  );

  return (
    <CategoryPreviewWrapper>
      <Flex marginBlockEnd={4}>
        <Text size="sm" fontWeight="bold">
          {translateSubElementString(
            "reportsPage.scopeThree.inputs.mainTotalEmissions"
          )}
        </Text>
        <NumberField value={totalCo2Emissions} marginStart="2" />
      </Flex>
      <DataTable
        data={businessTravelData}
        columns={columns}
        marginBlockEnd={8}
        containerHeight={businessTravelData && businessTravelData.length > 0 ? "300px" : null}
      />
      {transportModeItems && transportModeItems.length > 0 &&
        <Grid templateColumns="repeat(2, 1fr)" gap={2} overflow="auto">
          <GridItem>
            <Heading size="sm" marginBlock="1" align="left">
              {t("modeOfTransport")}
            </Heading>
          </GridItem>
          <GridItem>
            <Heading size="sm" marginBlock="1" align="right">
              {translateSubElementString("reportsPage.totalEmissions")}
            </Heading>
          </GridItem>
          {transportModeItems && transportModeItems.map(item => {
            return <Fragment key={`transportMode-${item.id}`}>
              <GridItem>
                <Box inlineSize="400px">
                  <Text
                    display="flex"
                    justifyContent="start"
                    alignItems="center"
                    fontSize="sm"
                    whiteSpace="break-spaces"
                    marginLeft={6}
                  >
                    {i18n.exists(`${questionnaireKeyPrefix}.modeOfTransportOptions.${item.modeOfTransport ?? ""}`) ?
                      inputsTranslation(`modeOfTransportOptions.${item.modeOfTransport}`) : item.modeOfTransport ?? ""}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <NumberField value={item.co2Emissions} />
              </GridItem>
            </Fragment>;
          })}
        </Grid>
      }
    </CategoryPreviewWrapper>
  );
}

export default BusinessTravelPreview;